/**
 * @class
 */
import Base from '@netx/core/lib/netx-collection';
import Model from '../models/batchJob';

class BatchJobs extends Base {
	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;
		super(models, opts);
	}

	/** @type {string} */
	static get __name__() {
		return 'BatchJobs';
	}
}

export default BatchJobs;
